import React from 'react';
import '../../css/randomEncounters.css';

import ListTable from './ListTable';

import columns from '../../json/randomEncountersColumns.json'
import rows from '../../json/randomEncounters.json';


function RandomEncounters(props){
  const caption = (<div className="caption"><span>First Die Roll</span> <span>1–12</span> <span>13–18</span> <span>19–20</span></div>)
  return (
    <div className="randomEncounters">
      <ListTable
        caption={caption}
        columns={columns}
        rows={rows}
        stateName={props.stateName}
        state={props.state}
        updateState={props.updateState}
      />
    </div>
  );
}

export default RandomEncounters;
